<template>
  <div v-if="!routeObj.hidden">
    <template v-if="routeObj.children && routeObj.children.length">
      <!--            下拉菜单-->
      <el-submenu v-if="routeObj.meta.subMenu" :index="routeObj.path">
        <template slot="title">
          <i :class="routeObj.meta.icon" v-if="routeObj.meta.icon"></i>
          <span>{{ routeObj.meta.title }}</span>
        </template>
        <menu-item v-for="(item, index) in routeObj.children" :key="index" :routeObj="item"/>
      </el-submenu>
      <!--            非下拉菜单-->
      <el-menu-item v-else :index="routeObj.children[0].path">
        <i :class="routeObj.children[0].meta.icon" v-if="routeObj.children[0].meta.icon"></i>
        <template slot="title">
          <span>{{ routeObj.children[0].meta.title }}</span>
        </template>
      </el-menu-item>
    </template>
    <template v-else>
      <el-menu-item :index="routeObj.path">
        <i :class="routeObj.meta.icon" v-if="routeObj.meta.icon"></i>
        <span>{{ routeObj.meta.title }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
  export default {
    name: "MenuItem",
    props: {routeObj: Object}
  }
</script>

<style scoped>

</style>
